import { useContext } from 'react'

import { CollectionGamesContext } from './useGameGrid'

export function useIsGameFavorited() {
  const { isFavorited } = useContext(CollectionGamesContext)
  return isFavorited
}
